import { _blog } from "../constants/api";

export const fetchBlog = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_blog}`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      return(`Failed to fetch blog: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in blog API ==> ', error);
    throw error;
  }
};

export const createBlog = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;
    if (!token) {
      throw new Error('Token not found');
    }
    const response = await fetch(`${_blog}`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      return `Failed to create blog`;
    }

    return await response.json();
  } catch (error) {
    console.log('Error in create blog ==> ', error);
    throw error;
  }
};

export const deleteBlog = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_blog}/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      return (`Failed to delete blog: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in delete blog API ==> ', error);
    throw error;
  }
};
